export default {
    ready: () => {

        const $tourTabs = $('.tours-tabs .nav-tabs');

        /**
         * Handle changing the window URL from tab clicking
         */
        if ($tourTabs.length > 0) {
            const originalTitle = $("meta[property='og:title']").attr('content');
            const currentTabIndex = $tourTabs.find('li.active').index();

            const itineraryDay = $('.tours-tabs').data('itinerary-day')

            if (itineraryDay > 0 && currentTabIndex === 1) {
                const $dayContent = $("#ataccordion1_" + itineraryDay)
                if ($dayContent.length > 0) {
                  $('html, body').animate({
                    scrollTop: $dayContent.offset().top - 200
                  }, 2000);
                }
            }

            window.history.replaceState({ tab: currentTabIndex }, originalTitle, window.location.href);

            $(document).on('click', '.itinerary-links a', function(e) {
                //load content with ajax
                const link = $(e.currentTarget);
                const tabPanel = $('.tours-tabs');
                const tab = tabPanel.find('.nav-tabs li').eq(1);
                //const link = tab.find('a');
                const tabPane = tabPanel.find('.tab-pane').eq(1);
                tabPanel.find('.active').removeClass('active').removeClass('in');
                tab.addClass('active in');
                tabPane.addClass('active in');

                const newTitle = originalTitle.replace('- Odyssey Traveller', 'Itinerary - Odyssey Traveller')
                window.history.pushState({ tab: 1 }, newTitle, link.attr('href'));
                document.title = newTitle

                const $itineraryContent = $("#ataccordion1_" + link.data('day'));
                // scroll if it exists
                if ($itineraryContent.length > 0) {
                  $('html, body').animate({
                    scrollTop: $("#ataccordion1_" + link.data('day')).offset().top - 200
                  }, 2000);
                }

                e.preventDefault();
                return false;
            });

            $('.tours-tabs .nav-tabs').on('click', 'a', function(e){
                var link = $(this),
                  tab  = $(this).parent(),
                  tabIndex = tab.index(),
                  tabPanel = $(this).closest('.tours-tabs'),
                  tabPane = tabPanel.find('.tab-pane').eq(tabIndex);
                tabPanel.find('.active').removeClass('active').removeClass('in');
                tab.addClass('active in');
                tabPane.addClass('active in');
                const newTitle = originalTitle.replace('- Odyssey Traveller', link.text() + ' - Odyssey Traveller')
                window.history.pushState({ tab: tabIndex }, newTitle, link.attr('href'));
                document.title = newTitle
                e.preventDefault();
                return false;
            });

            $(window).on('popstate', function (e) {
                const state = e.originalEvent.state;
                if (state === null) {
                    return
                }
                //load content with ajax
                const tabPanel = $('.tours-tabs')
                const tab = tabPanel.find('.nav-tabs li').eq(state.tab);
                //const link = tab.find('a');
                const tabPane = tabPanel.find('.tab-pane').eq(state.tab);
                tabPanel.find('.active').removeClass('active').removeClass('in');
                tab.addClass('active in');
                tabPane.addClass('active in');
            });
        }

        // scroll to top
        $(window).scroll(() => {
            if ($(window).scrollTop() >= $(window).height()) {
                $('.return-top--attached').fadeIn();
            } else {
                $('.return-top--attached').fadeOut();
            }
        });

        $('.return-top').click(() => {
            $('html, body').animate({scrollTop: 0}, 'slow');
            return false;
        });

        // affix
        $('.tour-submenu').affix({
            offset: {
                top: function() {
                    if ($('#widget-call-to-action-1').length > 0) {
                        return  $('#widget-call-to-action-1').offset().top + $('#widget-call-to-action-1').outerHeight(true);
                    }
                    if ($('#widget-slider-1').length > 0) {
                        return  $('#widget-slider-1').offset().top + $('#widget-slider-1').outerHeight(true);
                    }
                    return 0;
                },
                bottom: function () {
                    const subscribeOffset = $('.form-subscribe.parallax-section').length > 0 ? $('.form-subscribe.parallax-section').outerHeight(true) : 0;
                    return (this.bottom = $('.footer').outerHeight(true) + subscribeOffset + 37.5)
                }
            }
        })

    },
};
